<template>
  <div class="hello">
    <header  >
    </header>

    <div style="margin-top: 20px;padding-bottom: 8rem">
      <div style="background-color: #6e9bcf">
        <div class="myInforHeader">
          <div class="myInfor">
            <div class="myImg">
              <img  src="@/assets/img/tx.jpg" alt="">
            </div>

            <div v-if="list.nickName">
              <span style="font-weight: 700;font-size: 20px">{{list.nickName}}</span>
              <p style="font-size: 12px">{{list.company_name}} | {{list.positions}}</p>
            </div>
            <div v-else>
              <span style="font-weight: 700;font-size: 15px">请完善个人信息</span>
              <!--<p style="font-size: 12px">{{list.company_name}}|{{list.position}}</p>-->
            </div>
          </div>

          <div class="">
            <!--<img class="edit" src="../assets/img/edit.jpg" alt="">-->

            <router-link to="/comMyinfor"><span class="word">编辑</span></router-link>
          </div>
        </div>
      </div>
      <div class="dynamic">
        <div class="dynamicDiv">
          <span >32</span>
          <span >动态</span>
        </div>
        <div class="dynamicDiv">
          <span >32</span>
          <span >我的关注</span>
        </div>
        <div class="dynamicDiv">
          <span >32</span>
          <span >粉丝</span>
        </div>
        <div class="dynamicDiv">
          <span >32</span>
          <span >点赞</span>
        </div>
      </div>

      <!--<div class="vip">-->
        <!--<span class="vipword">VIP</span>升级vip享专属权益  <a class="sj" href="#">去升级</a>-->
      <!--</div>-->
      <div class="vipDiv" :style="style">
        <div class="vipDivImg" style="width: 5rem">
          <img style="width: 100%;height: 100%" src="@/assets/img/9.png" alt="">
        </div>
        </div>
      <br>
      <hr>
      <div class="list">
        <!--<div class="qzzs">-->
        <!--<div class="jobList">-->
          <!--&lt;!&ndash;<span class="qzzsword">求职助手</span>&ndash;&gt;-->
          <!--<p>求职助手</p>-->
          <!--<div style="display: flex;justify-content: space-between">-->
            <!--<div class="listjl">-->
              <!--<span>简历曝光 &ensp;</span>-->
              <!--<img style="width: 30px" src="@/assets/img/14.png" alt="">-->
            <!--</div>-->
            <!--<div class="listjz">-->
              <!--<span>竞争力分析</span>-->
              <!--<img style="width: 30px" src="@/assets/img/15.png" alt="">-->

            <!--</div>-->

          <!--</div>-->
        <!--</div>-->
        <ul class="listResume">

          <li @click="toMyCom"><span class="listResumes1"><van-icon name="todo-list-o" size="23" color="#6e9bcf"/><span style="margin-left: 10px">我的公司</span></span><span class="listResumes2" ></span></li>

          <li><span class="listResumes1"><van-icon name="user-o" size="23"  color="#6e9bcf"  /><span style="margin-left: 10px">专属招聘顾问</span></span>
            <!--<span class="listResumes2" ></span>-->
          </li>
          <li><span class="listResumes1"><van-icon name="service-o" size="23" color="#6e9bcf" /><span style="margin-left: 10px">在线客服</span></span><span class="listResumes2" ></span></li>
          <!--<li><span class="listResumes1"><img src="@/assets/img/19.png" alt=""><span>提升简历曝光</span></span><span class="listResumes2" ></span></li>-->

        </ul>
        <ul class="listResume">
          <li @click="toHome"><span class="listResumes1"><van-icon name="friends-o"  size="23" color="#6e9bcf" /><span style="margin-left: 10px">切换身份</span></span><span class="listResumes2" >切换至我要招人才</span></li>
          <router-link to="/changePassWord"><li><span class="listResumes1"><van-icon name="warn-o" size="23" color="#6e9bcf"/><span style="margin-left: 10px">账号安全</span></span><span class="listResumes2" >修改登录密码</span></li></router-link>
          <router-link to="/setPassWord"><li><span class="listResumes1"><van-icon name="setting-o" size="23" color="#6e9bcf" /><span style="margin-left: 10px">设置密码</span></span><span class="listResumes2" ></span></li></router-link>
          <li><span class="listResumes1"><van-icon name="balance-list-o"  size="23" color="#6e9bcf" /><span style="margin-left: 10px">关于我们</span></span><span class="listResumes2" ></span></li>
        </ul>
      </div>
      <a href="javascript:;" class="exitLogin" v-on:click="go">退出登录</a>
    </div>
    <van-tabbar route>
      <van-tabbar-item replace to="/comTalents" icon="wap-home-o">
        招人才
      </van-tabbar-item>
      <van-tabbar-item replace to="/comMessage" icon="envelop-o">
        消息
      </van-tabbar-item>
      <van-tabbar-item replace to="/comPosition" icon="desktop-o">
        职位
      </van-tabbar-item>
      <van-tabbar-item replace to="/comMy" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
  import pic from '@/assets/img/vip.png'
  import { apiAddress } from '@/utils/https/api';// 导入我们的api接口
  import { Button } from 'vant'
  export default {
    name: 'HelloWorld',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        list:{
          name:''
        },
        style:{
          backgroundImage:`url(${pic})`
        },
        active:0
      }
    },
    created(){
//this.getlist()
//    this.postForm('11')
    },
    mounted(){
//  this.postForm()
      this.onLoad()
//  let json={mobile: '17610336967'}
//  console.log(this.$api)

    },
    methods:{
      go(){
        localStorage.removeItem('userid')
        this.$router.push({ path:'/login'  })
      },
      toHome(){
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          });
        setTimeout(() => {
          this.$router.push("/")
          }, 2000);
       },
      toMyCom(){
        var a=null
        if(this.list.company_id){
          this.$router.push({
            path:`/comHomePage/${this.list.company_id}`
          })
        }else {
          this.$router.push("/myCompany")
        }
      },
      onLoad() {
        this.$api.getComMy({'id':localStorage.getItem("userid")}).
        then(res=>{

          this.list=res.data?res.data:{}

          localStorage.setItem("companyId",res.data.company_id)
          console.log(res)
          console.log(this.list)
        }).catch(err=>{

        })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*@import '../../assets/css/common.css';*/
  /*@import '../../assets/css/header.css';*/
  /*@import '../../assets/css/footer.css';*/
  /*@import '../../assets/css/my1.css';*/
  header{
    width: 100%;
    height: 25px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    /*display: flex;*/
    /*justify-content: space-between;*/
    /*align-items: center;*/
    padding: 0 1rem;
    color: #FFFFFF;
    z-index: 100;
  }
  .vipDiv{
    width: 90%;
    margin: auto;
    height: 4rem;
    /*background-image:url("../../assets/img/vip.png");*/
    /*background-color: #fff;*/
    background-repeat: no-repeat;
    background-size: 100% 100%;

  }
  .vipDiv img{
    width: 100%;
    height: 100%;
  }
  .vipDivImg{
    width: 5rem;
    right: 34px;
    float: right;
    margin: 20px;
  }
  .myImg{
    width: 70px;
    height: 70px;
  }
  .myImg img{
    width: 100%;
    border-radius: 100%;
  }
.myInfor{
display: flex;
  /*justify-content: space-between;*/
  align-items: center;
}
  .myInforHeader{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: auto;
    color: #FFFFFF;
   background-color: #6e9bcf;;
  }
  .dynamicDiv span{
    display: block;
    text-align: center;
  }
  .dynamic{
    display: flex;
    justify-content: space-evenly;
    padding:1rem 0px ;
  }
  .word{
    color: #FFFFFF;
  }
  .dynamic{
    display: flex;
    justify-content: space-evenly;
  }
  .age{
    font-size: 13px;
  }
  .dynamicDiv{
    /*display: flex;*/
  }
  .dynamicDiv span{
    display: block;
    text-align: center;
  }

  .editUser{
    display: flex;
    /*justify-content: center;*/
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: auto;
    padding-top: 15px;
  }
  .editUserRight img{
    width: 100%;
    border-radius: 100%;

  }
  .editUserRight{
    width: 80px;
    height: 80px;
  }
  .editUserLeft img{
    width: 20px;
    height: 20px;
  }
  .jobList{

  }
  .listjl{
    /*width: 30%;*/
    height: 56px;
    background: #fff;
    /*float: left;*/
    /*margin-top: 16px;*/
    /*margin-left: 40px;*/
    border-radius: 14px;
    border: 1px solid #999999;
    box-shadow: 2px 2px 2px #999999;
    /*text-align: center;*/
    /*line-height: 56px;*/
    font-size: 16px;
    display: flex;
    align-items: center;
    padding: 1px 5px;
  }
  .listjz{
    /*width: 30%;*/
    height: 56px;
    background: #fff;
    /*float: right;*/
    /*margin-top: 16px;*/
    /*margin-right: 40px;*/
    border-radius: 14px;
    border: 1px solid #999999;
    box-shadow: 2px 2px 2px #999999;
    /*text-align: center;*/
    /*line-height: 56px;*/
    font-size: 16px;
    display: flex;
    align-items: center;
    padding: 1px 5px;
  }
  .listResume{
    line-height: 44px;
    margin-top: 10px;
    padding: 0 6px;
  }
  .listResume img {
    width: 20px;
    height:20px;
    padding-right: 10px;
  }
  .listResume li{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .listResumes2{
    font-size: 12px;
    color: #c1c0c0;
  }
  .listResumes1{
    font-size: 15px;
    display: flex;
    align-items: center;
  }
  .exitLogin{
    display: block;
    width: 100%;
    line-height: 40px;
    text-align: center;
    color: red;
    background-color: #fff;
    margin-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/comMy.vue